export const isUserLoggedIn = () => !!localStorage.getItem('userData');

export const getUserData = () => JSON.parse(localStorage.getItem('userData'));
